import { getShellApiInstance } from '../../common/shell-api-helpers'
import { getProductTrialFromLocalStorage, isFreeUser, isTrialUser } from '../../common/user-helpers'
import { TrialBannerService } from '../../services/banner/trial-banner-service'
import { getProductTrialInfo } from '../../services/product'

export const initializeTrialBanner = () => {
  const isAuthenticated = !!getShellApiInstance()?.user?.key
  const trialBannerService = new TrialBannerService()
  if (isAuthenticated) {
    getProductTrialInfo().then(() => {
      if (canShowTrialBanner()) {
        trialBannerService.show()
      } else {
        trialBannerService.hide()
      }
    })
  }
}

/**
 * Checks if user has an active product trial to show the trial banner
 * @returns true/false
 */
export const canShowTrialBanner = (): boolean => {
  const isAuthenticated = !!getShellApiInstance()?.user?.key
  const productTrialExists = !!getProductTrialFromLocalStorage()
  if (!isAuthenticated) {
    return false
  }
  if (!productTrialExists) {
    return false
  }
  return isFreeUser() || isTrialUser()
}
